import axios from 'axios';
import constantes from "../constantes";
import router from "../router";
import store from "../store";

const PREFIJO="/api/PgWb/";

export default {
    crearPago(formulario,pasarela,tipo) {
        const usuario = store.getters.getUsuario;
        const cotizacion = store.getters.getCotizacion;
        const url = location.origin;
        let dto={};
        dto.dt4 = constantes.Constantes.enumeraciones.moneda.id;
        dto.dt5 = url+router.resolve({name: 'compras.contado',query: { tab: tipo.id , type:pasarela.name}}).href;
        dto.dt6 = url+router.resolve({name: 'compras.contado',query: { tab: tipo.id , type:pasarela.name}}).href;//url+router.resolve({name: cotizacion.bdt4 ? 'credito.detalle' : 'compras.detalle'}).href,
        dto.dt20 = usuario.dt1;
        dto.ndt1 = formulario.valor;//valor
        dto.ndt2 = cotizacion.ndt6;
        dto.ndt3 = cotizacion.ndt5;
        dto.ndt4 = constantes.Constantes.enumeraciones.idApp;
        dto.dt21 =  pasarela.dto;

        if (formulario.titular) {
            dto.bdt3 = formulario.titular
            dto.dt15 = formulario.nombre // NOMBRES TERCEROS
            dto.dt23 = formulario.apellido // APELLIDOS TERCEROS
            dto.dt24 = formulario.email // EMAIL
            dto.dt16 = formulario.numero // IDENTIFICACION TERCERO
            dto.dt17 = formulario.tipo.dt1 // TIPO IDENTIFICACION TERCERO
            dto.dt22 = formulario.celular // CELULAR TERCEROS
        }

        return axios.post(`${PREFIJO}VmCrPgWb`,dto);
    },
    actualizarEstados(pasarela){
        const usuario = store.getters.getUsuario;
        const cotizacion = store.getters.getCotizacion;
        const dto={
            ndt1:cotizacion.ndt5,//valor
            dt20:usuario.dt1,
            dt21:pasarela.dto
        };
        return axios.post(`${PREFIJO}VmAcPgWb`,dto);
    },
    consultaPagos(pasarela) {
        const cotizacion = store.getters.getCotizacion;
        const dto={
            dt1:pasarela.dto,
            ndt1:cotizacion.ndt5,//valor
            ndt2:0,
            ndt3:0,
        };
        return axios.post(`${PREFIJO}VmLsPgWbNg`,dto);
    },
    validarPagoP2P(){
        const usuario = store.getters.getUsuario;
        const dto = {
            dt1:usuario.dt1,
            ndt1:store.getters.getPago.respuesta.ndt1,
        };
        return axios.post(`${PREFIJO}VmCsPgWb`,dto);
    }
};
